import React, { Component } from 'react';
import propTypes from 'prop-types';
import throttle from 'lodash.throttle';

import Spinner from '~/Components/Global/Loading/Spinner';

import FontWrapper from '~/Containers/Global/FontWrapper/FontWrapper';

import createQuill from '~/Components/Quill/Quill';

import './MealPrep.scss';
import { TaskListHeader } from '~/Components/Pages/Calendar/Tasks';
import { MEAL_PREPS } from '~/Redux/Modules/UserOptions/constants';

class MealPrep extends Component {
  constructor() {
    super();
    this.quill = false;
    this.editor = false;
    this.state = {
      lastUpdate: false,
      fetched: false,
      creating: false,
      isUserEditing: false,
    };
  }

  handleSubmit = () => {
    const { currentDate, updateMealPrep, mealPrep } = this.props;
    const newBody = this.handleGetCurrentContents();
    console.log('handleSubmit', newBody);
    if (!mealPrep) {
      if (newBody === '<p><br></p>') return;
      this.setState({ lastUpdate: newBody, creating: true });
      return updateMealPrep({ body: newBody, date: currentDate });
    }

    if (this.state.lastUpdate && this.state.lastUpdate === newBody) return;
    this.setState({ lastUpdate: newBody, creating: false });
    return updateMealPrep({ ...mealPrep, body: newBody });
  };

  throttledUpdate = throttle(() => {
    this.handleSubmit();
  }, 3000);

  handleGetCurrentContents = () => {
    return this.quill.container.querySelector('.ql-editor').innerHTML.replace(/>\s+</g, '>&nbsp;<');
  };

  handleSetCurrentContents = html => {
    this.quill.off('text-change', this.handleTextChange);
    this.quill.setContents(this.quill.clipboard.convert(html));
    this.quill.history.clear();
    this.quill.on('text-change', this.handleTextChange);
  };

  componentDidMount = () => {
    this.quill = createQuill(this.editor, {
      formats: ['link'],
      modules: {
        toolbar: false,
        keyboard: { bindings: { noEnter: { key: 13, handler: () => true } } },
      },
    });

    this.quill.root.addEventListener('blur', () => this.handleBlur());
    this.quill.root.addEventListener('focus', () => this.handleSubmit());
    this.quill.on('text-change', this.handleTextChange);
    this.quill.enable(false);
  };

  componentDidUpdate(prevProps) {
    const { currentDate, mealPrep, isFetching } = this.props;
    const { isUserEditing } = this.state;
    if (prevProps.currentDate !== currentDate) {
      if (!mealPrep || !mealPrep.body) {
        this.handleSetCurrentContents('');
      }
    }
    if (
      prevProps.mealPrep !== mealPrep &&
      mealPrep &&
      mealPrep.body &&
      !isFetching &&
      !isUserEditing
    ) {
      this.handleSetCurrentContents(mealPrep.body);
    }
  }

  handleTextChange = () => {
    this.setState({ isUserEditing: true });
    if (!this.props.isFetching) this.throttledUpdate();
  };

  handleBlur = () => {
    this.setState({ isUserEditing: false });
    this.handleSubmit();
  };

  componentWillReceiveProps = nextProps => {
    this.quill.enable(!nextProps.isFetching);
    if (nextProps.isFetching) this.throttledUpdate.cancel();

    const currentContents = this.quill.root.innerHTML;

    if (this.props.isFetching && !nextProps.isFetching) {
      this.setState({ fetched: true });
    }

    if (nextProps.mealPrep && !this.state.fetched) {
      this.setState({ fetched: true });
      this.handleSetCurrentContents(nextProps.mealPrep.body);
    }

    if (nextProps.mealPrep && !this.props.mealPrep) {
      const nextContents = nextProps.mealPrep.body || '';
      if (currentContents !== nextContents) {
        this.setState({ fetched: true, creating: false });
        if (!this.state.creating) this.handleSetCurrentContents(nextProps.mealPrep.body);
      }
    }

    if (
      nextProps.mealPrep &&
      this.props.mealPrep &&
      (this.props.mealPrep.id !== nextProps.mealPrep.id ||
        this.props.mealPrep.fetchedAt !== nextProps.mealPrep.fetchedAt)
    ) {
      this.setState({ fetched: true });
      this.handleSetCurrentContents(nextProps.mealPrep.body);
    }

    if (!nextProps.mealPrep && !nextProps.isFetching) {
      if (!this.state.creating) {
        if (currentContents !== '') {
          this.handleSetCurrentContents('');
        }
        this.setState({ fetched: true, lastUpdate: '', creating: false });
      }
    }
  };

  handleClick = e => {
    console.log('handleClick', e.target, e.target.tagName);
    if (e.target.tagName === 'A') window.open(e.target.href, '_blank');
    this.quill.focus();
  };

  render() {
    const { isFetching, header, suffix, editableHeader, isMealsSectionCollapsed } = this.props;
    return (
      <div className="meal-prep" onClick={this.handleClick}>
        <h6 className="meal-prep-header">
          <TaskListHeader
            isSectionCollapsed={isMealsSectionCollapsed}
            type={MEAL_PREPS}
            heading={header}
            suffix={suffix}
            editable={editableHeader}
          />
          {isFetching && <Spinner />}
        </h6>
        <FontWrapper>
          <div ref={r => (this.editor = r)} />
        </FontWrapper>
      </div>
    );
  }
}

MealPrep.propTypes = {
  currentDate: propTypes.string,
  header: propTypes.string,
  isFetching: propTypes.bool,
  updateMealPrep: propTypes.func,
  mealPrep: propTypes.oneOfType([propTypes.string, propTypes.object]),
  suffix: propTypes.string,
  editableHeader: propTypes.bool,
  isMealsSectionCollapsed: propTypes.bool,
};

MealPrep.defaultProps = {
  header: 'MEALS',
};

export default MealPrep;
